import React, { useContext, useState } from 'react';
import { Button, Form, InputGroup, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

import { userDetailsResource } from '../../../../../resource';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import TenantContext from '../../../../../hoc/Context/TenantContext';

const errorByStatus = {
  404: 'notFound',
  default: 'common'
};

const UserDetailsProvider = ({ providerName, onUserDetails }) => {
  const { formatMessage } = useIntl();
  const { tenant } = useContext(TenantContext);
  const [{ isLoading, error }, setSearchState] = useState({});
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);

  const handleCloseLDAPLogin = () => setShow(false);
  const handleShowLDAPLogin = () => setShow(true);
  const handleUsername = event => {
    setUsername(event.target.value);
  }
  const handlePassword = event => {
    setPassword(event.target.value)
  }

  const searchForUser = () => {

    userDetailsResource
      .getUserDetails(username, password, tenant)
      .then(({ externalId: _, ...userDetails }) => {
        setSearchState(prevState => ({ ...prevState, isLoading: false }));
        onUserDetails({ ...userDetails, neptunId: username });
        handleCloseLDAPLogin();
      })
      .catch(error => {
        console.error('Failed to search for user details', error);
        setSearchState(prevState => ({
          ...prevState,
          isLoading: false,
          error: errorByStatus[error.status] || errorByStatus.default
        }));
      });
  };

  return (
    <Form.Group className={`user-details-provider ${providerName}`}>
      <Form.Label>{formatMessage({ id: `LDAP.registration` })}</Form.Label>
      <InputGroup>
        <Button onClick={handleShowLDAPLogin}>
          <img
            src={`${process.env.PUBLIC_URL}/logos/${providerName}.png`}
            alt={`${providerName} logo`}
          />
        </Button>
        <div className={classNames({ 'is-invalid': !!error })}></div>
        <Modal show={show} onHide={handleCloseLDAPLogin}>
          <Modal.Header closeButton>
            <Modal.Title>{formatMessage({ id: `LDAP.modal.modalTitle` })}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Label>{formatMessage({ id: `LDAP.modal.username` })}</Form.Label>
            <Form.Control
              name="username"
              value={username}
              disabled={isLoading}
              onChange={handleUsername}
            />
            <Form.Label>{formatMessage({ id: `LDAP.modal.password` })}</Form.Label>
            <Form.Control
              name="password"
              type="password"
              value={password}
              disabled={isLoading}
              onChange={handlePassword}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseLDAPLogin}>
              {formatMessage({ id: `LDAP.modal.close` })}
            </Button>
            <Button variant="primary" onClick={searchForUser} disabled={!username || !password}>
              {isLoading ? (
                <FontAwesomeIcon icon={faSpinner} spin={isLoading} />
              ) : (
                formatMessage({ id: 'LDAP.modal.request' })
              )}
            </Button>
          </Modal.Footer>
        </Modal>
        {error && (
          <Form.Control.Feedback type="invalid">
            {formatMessage({ id: `providers.${providerName}.error.${error}` })}
          </Form.Control.Feedback>
        )}
      </InputGroup>
    </Form.Group>
  );
};

UserDetailsProvider.propTypes = {
  providerName: PropTypes.string.isRequired,
  onUserDetails: PropTypes.func.isRequired
};

export default UserDetailsProvider;
